// src/components/ui/Button.jsx

import React from "react";
import clsx from "clsx";

const Button = ({ children, variant = "primary", size = "md", disabled = false, onClick }) => {
  const baseStyles =
    "font-semibold rounded transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2";

  const variants = {
    primary: "bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500",
    secondary: "bg-gray-200 text-gray-800 hover:bg-gray-300 focus:ring-gray-400",
    outline: "border border-blue-600 text-blue-600 hover:bg-blue-50 focus:ring-blue-500",
  };

  const sizes = {
    xs: "px-2 py-1 text-xs sm:px-3 sm:py-1 sm:text-sm md:px-3 md:py-1 md:text-sm lg:px-4 lg:py-2 lg:text-base xl:px-4 xl:py-2 xl:text-base",
    sm: "px-2 py-1 text-xs sm:px-3 sm:py-1 sm:text-sm md:px-3 md:py-1 md:text-sm lg:px-4 lg:py-2 lg:text-base xl:px-4 xl:py-2 xl:text-base",
    md: "px-3 py-2 text-sm sm:px-4 sm:py-2 sm:text-base md:px-5 md:py-2 md:text-base lg:px-6 lg:py-3 lg:text-lg xl:px-6 xl:py-3 xl:text-lg",
    lg: "px-4 py-3 text-base sm:px-5 sm:py-3 sm:text-lg md:px-6 md:py-3 md:text-lg lg:px-7 lg:py-4 lg:text-xl xl:px-8 xl:py-4 xl:text-xl",
    xl: "px-6 py-4 text-lg sm:px-7 sm:py-4 sm:text-xl md:px-8 md:py-5 md:text-2xl lg:px-10 lg:py-6 lg:text-3xl xl:px-12 xl:py-6 xl:text-3xl",
  };

  return (
    <button
      className={clsx(baseStyles, variants[variant], sizes[size], disabled && "opacity-50 cursor-not-allowed")}
      disabled={disabled}
      onClick={onClick}
    >
      {children}
    </button>
  );
};

export default Button;